import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from '@fluentui/react-components';
import { tokens } from './tokens.js';
const useStyles = makeStyles({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalXS,
        paddingBlock: tokens.spacingVerticalXXS,
        paddingInline: tokens.spacingHorizontalS,
        borderRadius: tokens.borderRadiusCircular,
        minWidth: 0,
    },
    dot: { flexShrink: 0, width: '8px', height: '8px', borderRadius: '50%' },
    label: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        fontWeight: tokens.fontWeightSemibold,
        whiteSpace: 'nowrap',
    },
});
/** Tone to its dot colour and the tint behind it. `neutral` is for a state that is neither good nor bad, such as Inactive. */
const toneStyle = {
    good: { dot: tokens.colorComplianceGood, tint: tokens.colorStatusTintGood },
    warning: { dot: tokens.colorComplianceWarning, tint: tokens.colorStatusTintWarning },
    critical: { dot: tokens.colorComplianceCritical, tint: tokens.colorStatusTintCritical },
    attention: { dot: tokens.colorComplianceAttention, tint: tokens.colorStatusTintAttention },
    neutral: { dot: tokens.colorNeutralForeground3, tint: tokens.colorNeutralBackground2 },
};
/**
 * A state as a tinted pill: a dot, then the words (Figma "Portal / Status badge", and the blue
 * "Needs review" attention badge 987:282 accepted with Roster v2).
 *
 * `StatusDot` stays the plain dot-and-text form the 06b frames draw; this is the pill the Roster v2
 * frames draw. The dot is `aria-hidden` and the words carry the meaning, so colour is never the only
 * signal (WCAG 1.4.1).
 */
export function StatusBadge({ tone, children }) {
    const styles = useStyles();
    const { dot, tint } = toneStyle[tone];
    return (_jsxs("span", { className: styles.root, style: { backgroundColor: tint }, children: [_jsx("span", { className: styles.dot, style: { backgroundColor: dot }, "aria-hidden": "true" }), _jsx("span", { className: styles.label, children: children })] }));
}
//# sourceMappingURL=StatusBadge.js.map